import React from 'react';

interface DesignDefaultSectionBlockProps {
  stepNumber: number;
  title: string;
  onEdit: () => void;
  children: React.ReactNode;
  icon?: React.ReactNode;
  isCompleted?: boolean;
  className?: string;
}

const DesignDefaultSectionBlock: React.FC<DesignDefaultSectionBlockProps> = ({
  stepNumber,
  title,
  onEdit,
  children,
  isCompleted,
  icon,
  className = '',
}) => {
  return (
    <div className={`bg-card-bg-light dark:bg-card-bg-dark p-5 sm:p-6 rounded-lg shadow-md dark:shadow-lg relative ${className}`}>
      <div className="flex justify-between items-center mb-4">
        <div className="flex items-center">
          <span
            className={`flex items-center justify-center w-6 h-6 sm:w-5 leading-normal sm:h-5 ${isCompleted ? 'bg-green-400 dark:bg-green-800 text-gray-50 dark:text-gray-200' : 'bg-gray-400 dark:bg-gray-700 text-gray-50 dark:text-gray-400'} rounded-full text-sm font-semibold mr-3`}>
            {stepNumber}
          </span>
          {icon && <span className="mr-2 text-primary">{icon}</span>}
          <h3
            className={`text-base sm:text-lg font-semibold ${isCompleted ? 'text-green-400 dark:text-green-800' : 'text-gray-400 dark:text-gray-400'}`}>{title}</h3>
        </div>
        {isCompleted && (
          <button 
            className="absolute right-4 top-4 sm:right-6 sm:top-6 flex flex-col items-center text-center cursor-pointer hover:opacity-75 transition-opacity" 
            onClick={onEdit}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
              <path d="M10.8802 6.26591H7.43612C6.05835 6.26591 5.36946 6.26591 4.84323 6.53404C4.38033 6.76989 4.00399 7.14624 3.76813 7.60913C3.5 8.13537 3.5 8.82426 3.5 10.202V17.0902C3.5 18.468 3.5 19.1569 3.76813 19.6831C4.00399 20.146 4.38033 20.5224 4.84323 20.7582C5.36946 21.0264 6.05835 21.0264 7.43612 21.0264H14.3243C15.7021 21.0264 16.391 21.0264 16.9172 20.7582C17.3801 20.5224 17.7565 20.146 17.9923 19.6831C18.2605 19.1569 18.2605 18.468 18.2605 17.0902V13.6461M8.42013 16.1062H9.7933C10.1944 16.1062 10.395 16.1062 10.5838 16.0609C10.7511 16.0207 10.9111 15.9545 11.0578 15.8645C11.2233 15.7631 11.3652 15.6213 11.6488 15.3376L19.4905 7.49594C20.1698 6.81661 20.1698 5.7152 19.4905 5.03587C18.8112 4.35653 17.7098 4.35653 17.0304 5.03586L9.18871 12.8776C8.90506 13.1612 8.76323 13.303 8.66181 13.4685C8.57189 13.6153 8.50562 13.7753 8.46545 13.9426C8.42013 14.1314 8.42013 14.3319 8.42013 14.7331V16.1062Z" stroke="var(--color-black)" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            <span className="text-xs mt-1">Editar</span>
          </button>
        )}
      </div>
      <div className="text-sm text-text-secondary dark:text-gray-300 space-y-1 pl-1">
        {children}
      </div>
    </div>
  );
};

export default DesignDefaultSectionBlock; 